import _ from 'lodash'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import { TweenMax, CSSPlugin } from 'gsap/all'
const gsapPlugins = [ TweenMax, CSSPlugin ]

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
